<script setup>

import LandingPageNavBar from '@/components/navigation/LandingPageNavigationBar.vue';
import ContactForm from '@/components/forms/ContactForm.vue';
</script>

<template>
  <LandingPageNavBar />
  <ContactForm />
</template>

<style scoped>

</style>
